import { createFileRoute, redirect } from '@tanstack/react-router'
import { getV1MeRetrieveQueryOptions } from '@/api/client'
import { CurriculumPlanScreen } from '@/components/curriculum/curriculum-plan-screen'

/**
 * Plan nauczania — cykl życia wersji planu.
 *
 * Cały widok siedzi w `CurriculumPlanScreen`; tutaj zostaje bramka roli.
 * Odczyt planu jest dla admina i superadmina (`CurriculumAdminReadView`) —
 * ten sam wzorzec, co `/quizy-automatyczne`.
 *
 * Poziomu 2 (`/plan-nauczania/jednostka/$n`) nie ma od wycięcia modelu
 * kolejkowego — razem z nim odpadł stary parametr `?podglad=`, bo nie ma już
 * dokąd przekierowywać.
 */
export const Route = createFileRoute('/_panel/plan-nauczania/')({
  beforeLoad: async ({ context }) => {
    const me = await context.queryClient.ensureQueryData(getV1MeRetrieveQueryOptions())
    if (me.status === 200 && me.data.role !== 'admin' && me.data.role !== 'superadmin') {
      throw redirect({ to: '/' })
    }
  },
  component: CurriculumPlanScreen,
})
